import { AuthService } from './../../services/auth.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidateService } from '../../services/validate.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  email: string;
  password: string;
  cpassword: string;
  signUpClicked: Boolean = false;
  passwordMatch: Boolean = true;
  somethingMissing: Boolean = false;
  userType: string = 'bankUser';
  submitOtpClicked: Boolean = false;
  showmsg: string = '';
  showmsgcheck: Boolean = false;

  code: any;
  verificationCode: any;
  signupForm: FormGroup;
  submitClicked: boolean = false;
  errorMessage: string = '';

  constructor(
    private router: Router,
    private auth: AuthService,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.signupForm = this.fb.group(
      {
        email: ['', [Validators.required]],
        password: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
            ),
          ],
        ],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validators: [
          (formGroup: FormGroup) => {
            const { password, confirmPassword } = formGroup.value;

            if (password !== confirmPassword) {
              return { passwordsDontMatch: true };
            } else {
              return null;
            }
          },
        ],
      }
    );
  }

  ngOnInit() {}

  handleSignup() {
    this.submitClicked = true;

    if (this.signupForm.invalid) return;

    this.auth
      .registerUser(this.signupForm.value)
      .pipe(
        finalize(() => {
          this.submitClicked = false;
        })
      )
      .subscribe(
        () => {
          this.router.navigateByUrl('/login');
        },
        (error) => {
          let msg = '';
          if (error.error.msg) {
            msg = error.error.msg;
          } else {
            msg = 'Something went wrong';
          }

          this.presentToast(msg);
        }
      );
  }

  presentToast(msg) {
    this.errorMessage = msg;
    setTimeout(() => {
      this.errorMessage = '';
    }, 3000);
  }
}
